import React from 'react';
import { ClaimItem } from '../../api/types';
import { formatPrice } from '../../money';

type PurchaseSummaryProps = {
  item: ClaimItem;
  orderNumber: string | null;
};

export function PurchaseSummary({ item, orderNumber }: PurchaseSummaryProps) {
  return (
    <div className="external-sales-success__summary">
      <h1 className="h4 mb-2">You’re all set!</h1>
      <p className="text-muted mb-4">Your purchase is confirmed.</p>
      <div className="d-flex justify-content-between align-items-center">
        <span className="external-sales-success__item-name">{item.name}</span>
        <span className="external-sales-success__item-price h5 mb-0">{formatPrice(item.price)}</span>
      </div>
      {orderNumber && (
        <>
          <p className="text-muted mt-3 mb-0">
            Order #
            {orderNumber}
          </p>
          <p className="text-muted mt-2 mb-0">
            <strong>Save your order number</strong>
            {' '}
            — take a screenshot or write it down.
          </p>
          <p className="text-muted mt-2 mb-0">
            Your activation code is on its way by email. If it hasn&rsquo;t arrived within
            an hour, contact support with this number and we&rsquo;ll help.
          </p>
        </>
      )}
      <p className="text-muted mt-4 mb-0">
        Check your email for your access link and code — open it on your phone to redeem in the app.
      </p>
    </div>
  );
}
